export default __webpack_public_path__ + "static/media/004.d7077ccd.png";